'use client';

import { TableBase } from './TableBase';

import type {
  DistributiveOmit,
  TableBaseImplProps,
} from './TableBaseImpl.types';

export type { ColumnDef } from './TableBaseImpl.types';

type PaginatedTableProps<T> = DistributiveOmit<
  TableBaseImplProps<T>,
  'paginationMode' | 'onLoadMore' | 'hasMore'
>;

export function PaginatedTable<T extends Record<string, any>>(
  props: PaginatedTableProps<T>,
) {
  return <TableBase {...props} paginationMode="classic" />;
}
